import React, { useState } from "react";
import { SKILL_TABLES } from "./helpers";
import { Skill } from "./types";

interface SkillModalProps {
  onSave: (skill: Skill) => void;
  onClose: () => void;
}

export const SkillModal = ({ onSave, onClose }: SkillModalProps) => {
  const [table, setTable] = useState("");
  const [skillName, setSkillName] = useState("");
  const [description, setDescription] = useState("");

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-3">
      <div className="ledger-shell p-4 max-w-2xl w-full text-sm">
        <h3 className="text-base font-semibold mb-3 uppercase tracking-wider">
          Gain New Skill
        </h3>
        <div className="space-y-4">
          <div>
            <label className="block text-xs font-semibold text-[#E6E5D3] mb-1 uppercase tracking-wider">
              Skill Table
            </label>
            <select
              value={table}
              onChange={(e) => {
                setTable(e.target.value);
                setSkillName("");
              }}
              className="w-full bg-[#222] text-[#E6E5D3] px-3 py-2 focus:outline-none text-sm"
            >
              <option value="">-- Select Table --</option>
              {Object.keys(SKILL_TABLES).map((t) => (
                <option key={t} value={t}>
                  {t === "Stealth_and_Speed" ? "Stealth & Speed" : t}
                </option>
              ))}
              <option value="Custom">Custom/Patron</option>
            </select>
          </div>
          {table && table !== "Custom" && (
            <div>
              <label className="block text-xs font-semibold text-[#E6E5D3] mb-1 uppercase tracking-wider">
                Skill Name
              </label>
              <select
                value={skillName}
                onChange={(e) => setSkillName(e.target.value)}
                className="w-full bg-[#222] text-[#E6E5D3] px-3 py-2 focus:outline-none text-sm"
              >
                <option value="">-- Select Skill --</option>
                {SKILL_TABLES[table as keyof typeof SKILL_TABLES]?.map((skill) => (
                  <option key={skill} value={skill}>
                    {skill}
                  </option>
                ))}
              </select>
            </div>
          )}
          {table === "Custom" && (
            <div>
              <label className="block text-xs font-semibold text-[#E6E5D3] mb-1 uppercase tracking-wider">
                Skill Name (Custom)
              </label>
              <input
                type="text"
                value={skillName}
                onChange={(e) => setSkillName(e.target.value)}
                className="w-full bg-[#222] text-[#E6E5D3] px-3 py-2 focus:outline-none text-sm"
                placeholder="Enter custom skill name..."
              />
            </div>
          )}
          {table && (
            <div>
              <label className="block text-xs font-semibold text-[#E6E5D3] mb-1 uppercase tracking-wider">
                Description (Optional)
              </label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="w-full bg-[#222] text-[#E6E5D3] px-3 py-2 focus:outline-none text-sm"
                rows={3}
                placeholder="Add skill description or notes..."
              />
            </div>
          )}
        </div>
        <div className="flex gap-2 mt-6">
          <button
            onClick={() => {
              if (!table || !skillName.trim()) {
                alert("Please select a table and skill name");
                return;
              }
              onSave({
                name: skillName.trim(),
                table:
                  table === "Stealth_and_Speed" ? "Stealth & Speed" : table,
                description: description.trim(),
              });
            }}
            className="flex-1 ledger-btn px-3 py-2 text-xs uppercase tracking-wider font-semibold"
          >
            Add Skill
          </button>
          <button
            onClick={onClose}
            className="flex-1 ledger-btn-critical px-3 py-2 text-xs uppercase tracking-wider font-semibold"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
